module.exports = __webpack_public_path__ + "static/media/OurWorkCategory_Tablet.0b931e87.svg";